module.exports = __webpack_public_path__ + "static/media/after_mario.0d1d76a0.mp3";